import * as React from 'react';

import { useStrings } from 'src/providers';

import { ReactComponent as Bullet } from 'src/images/bullet-checkmark.svg';
import { ReactComponent as FAQIcon } from 'src/images/faq-icon.svg';

import { FaqButton, StyledContractDetails } from './StyledContractDetails';

interface IContractDetailsProps {
  onChangeTab?: React.MouseEventHandler<HTMLButtonElement>;
}

const ContractDetails = (props: IContractDetailsProps) => {
  const { bullets, bulletsHeadline, faqButton } = useStrings();
  const { onChangeTab } = props;

  const renderBullet = (bullet: string, index: number) => {
    return (
      <li key={index} className="bullet">
        <Bullet className="checkmark" />
        <span className="text">{bullet}</span>
      </li>
    );
  };

  const maybeRenderChangeTabBullet = React.useCallback(() => {
    if (!onChangeTab) {
      return null;
    }

    return (
      <li className="bullet change-tab">
        <FaqButton
          id="faqbutton"
          onClick={onChangeTab}
          title="FAQ"
          type="button"
        >
          <FAQIcon className="icon" />
          <span className="text">{faqButton}</span>
        </FaqButton>
      </li>
    );
  }, [onChangeTab]);

  return (
    <StyledContractDetails className="contract-details" id="contract_details">
      <h2 className="headline" data-test="summary-text">
        {bulletsHeadline}
      </h2>

      <ul className="bullets">
        {bullets.map(renderBullet)}
        {maybeRenderChangeTabBullet()}
      </ul>
    </StyledContractDetails>
  );
};

export default ContractDetails;
